var map = {
	"./app/timevault.jpg": 618,
	"./app/website.jpg": 812,
	"./experience.svg": 71,
	"./jambit.svg": 318,
	"./jm.jpg": 252,
	"./tintenklecks.png": 534,
	"./trumpf.svg": 613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;